import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { renderAsync } from 'docx-preview';
import * as Sentry from '@sentry/angular';
import { HeaderDto } from 'src/app/dto/header.dto';
import { FilesHelperService } from 'src/app/services/files-helper.service';

const DOCX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

@Component({
  selector: 'app-data-processing-terms',
  templateUrl: './data-processing-terms.component.html',
  styleUrls: ['./data-processing-terms.component.scss']
})
export class DataProcessingTermsComponent implements OnInit {
  @ViewChild('docxContainer', { static: true }) docxContainer!: ElementRef;
  headerDataValues: HeaderDto = {
    title: 'Условия обработки персональных данных',
    downloadOption: true
  };

  private docxFilePath = '/assets/AppsDocs/data ProcessingTermms.docx';
  private fileContent: ArrayBuffer | null = null;

  constructor(private readonly filesHelper: FilesHelperService) {}

  ngOnInit(): void {
    this.loadDocxFile(this.docxFilePath);
  }

  loadDocxFile(filePath: string): void {
    fetch(filePath)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => {
        this.fileContent = arrayBuffer;
        const container = this.docxContainer.nativeElement;
        renderAsync(arrayBuffer, container).catch(error => {
          Sentry.captureException(error);
        });
      })
      .catch(error => Sentry.captureException(error));
  }

  async onDownloadClicked(): Promise<void> {
    if (!this.fileContent) {
      return;
    }

    try {
      const fileName = 'data_processing_terms.docx';
      const blob = new Blob([this.fileContent], { type: DOCX_MIME_TYPE });
      // Сохраняем И открываем: на нативе прежде файл молча писался в песочницу без открытия/уведомления.
      await this.filesHelper.saveAndOpenFile(blob, fileName, DOCX_MIME_TYPE);
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
